module.exports = require("core-js/modules/es.regexp.test.js");